import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useNavigate } from "react-router-dom";
// ==============================|| MINIMAL LAYOUT ||============================== //

const MinimalLayout = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const token = localStorage.getItem("user-token");
  useEffect(() => {
    const currentPath = window.location.pathname;

    if (token) {
      if (currentPath === "/auth/user-login") {
        navigate("/user/dashboard");
      } else if (currentPath === "/auth/admin-login") {
        navigate("/admin/dashboard");
      }
    } else {
      setIsLoading(false);
    }
  }, [token, navigate]);

  if (isLoading) {
    return <></>; 
  }

  return (
    <>
      <Outlet />
    </>
  );
};

export default MinimalLayout;
